module.exports = __webpack_public_path__ + "static/img/noresult.cc29a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noresult.png
// module id = ucCa
// module chunks = 6